var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{style:(_vm.styleObject),attrs:{"editor":_vm.editor,"config":_vm.config},model:{value:(_vm.markup),callback:function ($$v) {_vm.markup=$$v},expression:"markup"}})}
var staticRenderFns = []

export { render, staticRenderFns }